export default "__VITE_ASSET__CAMqVvOf__"